import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'

export enum ReportsRoutesEnum {
    DatatableReportFinancial = '/relatorios/financeiro',
    DatatableSolicitationsReportFinancial = '/relatorios/exames',
    DatatableSubscriptionPayments = '/relatorios/pagamentos-assinatura',
}

export function ReportsRouter() {
    /*Rotas para Dashboard*/
    const DatatableReportFinancial = lazy(
        () => import('../../pages/reports/DatatableReportFinancial')
    )
    const DatatableSolicitationsReportFinancial = lazy(
        () => import('../../pages/reports/DatatableSolicitationsReportFinancial')
    )
    const DatatableSubscriptionPayments = lazy(
        () => import('../../pages/reports/DatatableSubscriptionPayments')
    )

    return (
        <Switch>
            {/*Rotas para Historico de Atividades*/}
            <Route
                path={ReportsRoutesEnum.DatatableReportFinancial}
                component={DatatableReportFinancial}
            />
            <Route
                path={ReportsRoutesEnum.DatatableSolicitationsReportFinancial}
                component={DatatableSolicitationsReportFinancial}
            />
            <Route
                path={ReportsRoutesEnum.DatatableSubscriptionPayments}
                component={DatatableSubscriptionPayments}
            />
        </Switch>
    )
}
